import { useEffect } from 'react'

// Tab title doubles as a live status badge, e.g.
//   "🔔 2 new · 1 preparing · 3 ready | Kitchen - Club"
// Counts lead so they survive tab truncation; zero counts are dropped to keep
// it short; with nothing active on the board it falls back to "Kitchen - Club".
//
// Sets document.title directly rather than via Inertia's <Head>: the inertia
// layout renders a plain <title> (no `inertia` attribute), and browsers report
// the first <title> in the document, so <Head title> never wins on the client.
export function KitchenHead({ account, newCount, preparingCount, readyCount }) {
  const base = `Kitchen - ${account.name}`
  const segments = [
    [newCount, 'new'],
    [preparingCount, 'preparing'],
    [readyCount, 'ready']
  ]
    .filter(([count]) => count > 0)
    .map(([count, label]) => `${count} ${label}`)

  const title = segments.length > 0 ? `🔔 ${segments.join(' · ')} | ${base}` : base

  useEffect(() => {
    const previous = document.title
    document.title = title
    // Hand the tab back its original title if the kitchen page is unmounted
    return () => {
      document.title = previous
    }
  }, [title])

  return null
}
